var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",style:({
    width: (_vm.size + "px")
  })},[_c('span',{staticClass:"loader-anim",style:({
      width: (_vm.size + "px"),
      height: (_vm.size + "px")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }